import Styles from './InstructionalScreenshot.module.scss'
import { FileType, FILE_SCREENSHOT, FILE_NAME, FILE_SCREENSHOT_TEXT } from './urlValidationUtils'
import { ReactComponent as ArrowIcon } from './instructionalArrow.svg'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = {
  fileType: FileType
}

export const InstructionalScreenshot = ({ fileType }: Props) => {
  const { isMobileMd } = useResponsiveDesign()
  if (fileType === FileType.PDF) return null

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>{FILE_NAME[fileType]} link needs to be publicly shared</div>
      <div className={Styles.text}>{FILE_SCREENSHOT_TEXT[fileType]}</div>
      <div className={Styles.screenshot}>
        <img alt={'Screenshot'} src={FILE_SCREENSHOT[fileType] || undefined} />
        {!isMobileMd && (
          <>
            <ArrowIcon
              className={cx(Styles.arrow, {
                [Styles.airtable]: fileType === FileType.AIRTABLE,
                [Styles.canva]: fileType === FileType.CANVA,
                [Styles.googleDocs]: fileType === FileType.DOCUMENT,
                [Styles.googleSheets]: fileType === FileType.SPREADSHEETS,
                [Styles.googleSlides]: fileType === FileType.PRESENTATION,
                [Styles.dropbox]: fileType === FileType.DROPBOX,
                [Styles.figma]: fileType === FileType.FIGMA,
                [Styles.googleDriveArrow]: fileType === FileType.FILE,
              })}
            />
            {fileType === FileType.AIRTABLE && <ArrowIcon className={cx(Styles.arrow, Styles.airtableSecondArrow)} />}
            {fileType === FileType.DROPBOX && <ArrowIcon className={cx(Styles.arrow, Styles.dropboxSecondArrow)} />}
            {fileType === FileType.FIGMA && <ArrowIcon className={cx(Styles.arrow, Styles.figmaSecondArrow)} />}
            {fileType === FileType.FILE && <ArrowIcon className={cx(Styles.arrow, Styles.googleDriveSecondArrow)} />}
          </>
        )}
      </div>
      <div className={cx(Styles.text, Styles.footerText)}>{FILE_NAME[fileType]} screenshot for reference</div>
    </div>
  )
}
